import { Stack } from '@mui/material'
import { queryClient } from '@common/config/api/queryClient'
import { SPACING } from '@common/theme/spacing'
import SubjectsTimepointsTable from '@features/subject/components/SubjectsTimepointsTable/SubjectsTimepointsTable'
import useStudySubjectsTimepointsTableHandlers from '../hooks/useStudySubjectsTimepointsTableHandlers'
import CreateStudySubjectDialog from '@features/study_details/Subjects/components/CreateStudySubjectDialog'
import { useGetSubjectsList } from '../hooks/useGetSubjectsList'

export default function SubjectsTimepoints() {
  const {
    page,
    subjectsTimepointsParams,
    handleSearch,
    handleAddClick,
    handlePageChange,
    handleRowsPerPageChange,
    handleRequestSort,
    isSubjectDialogVisible,
    setIsSubjectDialogVisible,
  } = useStudySubjectsTimepointsTableHandlers()

  const { data: subjectsList } = useGetSubjectsList(['SubjectsList'], subjectsTimepointsParams)

  return (
    <>
      <Stack spacing={SPACING.sectionsSpacing}>
        <SubjectsTimepointsTable
          onSearch={handleSearch}
          onAddClick={handleAddClick}
          searchValue={subjectsTimepointsParams.search ?? ''}
          page={page}
          subjectsTimepointsParams={subjectsTimepointsParams}
          onPageChange={(event, newPage) => handlePageChange(subjectsList?.data, event, newPage)}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRequestSort={handleRequestSort}
        />
      </Stack>
      {isSubjectDialogVisible ? (
        <CreateStudySubjectDialog
          onClose={(data) => {
            setIsSubjectDialogVisible(false)
            if (data) {
              queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
            }
          }}
        />
      ) : null}
    </>
  )
}
